<template>
  <IconLucideFolderLock />
</template>
